import alt from "../alt";

class TicketActions {
  constructor() {
    this.generateActions(
      "updateTickets",
      "fetchAllForPerson",
      "fetchAllForEvent",
      "fetchOne",
      "fetchFailed",
      "delete",
      "deleteTickets",
      "markAsUsed",
      "downloadPdf",
      "changeTicketsUnlock",
      "cancelTransfer",
      "resendTransfer",
      "editFailed",
      "exchangeTickets",
      "changeSeats"
    );
  }

  fetchTicketTransferHistory(ticketId, eventBucketId) {
    return { ticketId, eventBucketId };
  }

  updateTicket(id, ticket) {
    return { id, ticket };
  }

  transfer(ids, recipient) {
    return { ids, recipient };
  }
}

export default alt.createActions(TicketActions);



// WEBPACK FOOTER //
// ./src/app/actions/TicketActions.js